import { SettingsSubPageLayout } from '../../components/settings/SettingsSubPageLayout';
import pt from '../../locales/pt';

export function SettingsHelp() {
  return (
    <SettingsSubPageLayout
      section={pt.settings.help.section}
      title={pt.settings.help.title}
      subtitle={pt.settings.help.subtitle}
    >
      <div className="space-y-3">
        {pt.settings.help.items.map((item) => (
          <article
            key={item.title}
            className="rounded-2xl border border-border bg-card p-4"
          >
            <h2 className="font-display text-base font-semibold text-foreground">{item.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
          </article>
        ))}
      </div>
    </SettingsSubPageLayout>
  );
}
